module.exports = __webpack_public_path__ + "img/seives.a47aca5c.png";